"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.regexp.replace");
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _typeof2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _router = _interopRequireDefault(require("@/router"));
var _slideLogin = _interopRequireDefault(require("./slideLogin"));
var _background_login = _interopRequireDefault(require("@/assets/img/background_login.jpg"));
var _title_img = _interopRequireDefault(require("@/assets/img/title_img.png"));
var _user = require("@/api/system/user");
var _utils = require("@/utils");
var _version = _interopRequireDefault(require("@/utils/version"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _sendActivationEmail = _interopRequireDefault(require("./sendActivationEmail"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Login',
  components: {
    slideLogin: _slideLogin.default,
    dragDialog: _DragDialog.default,
    sendActivationEmail: _sendActivationEmail.default
  },
  data: function data() {
    var _this = this;
    var validateUsername = function validateUsername(rule, value, callback) {
      if (!value) {
        callback(new Error(_this.$t('login.userError')));
      } else {
        callback();
      }
    };
    var validatePassword = function validatePassword(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error(_this.$t('login.passwordRequire')));
      }
      callback();
      // if (value.length < 8) {
      //   callback(new Error(this.$t('login.passwordError')))
      // } else {
      //   callback()
      // }
    };
    var validateCheckCode = function validateCheckCode(rule, value, callback) {
      if (!value) {
        callback(new Error(_this.$t('login.checkRequire')));
      } else if (value.length !== 4) {
        callback(new Error(_this.$t('login.checkError')));
      } else {
        callback();
      }
    };
    return {
      showData: false,
      dialogVisible: false,
      checkedUser: false,
      remberPassward: false,
      sendActivationEmailVisible: false,
      sendActivationEmailUsername: '',
      imgList: {},
      version: _version.default,
      loginBg: _background_login.default,
      loginTitle: _title_img.default,
      loginForm: {
        username: '',
        password: '',
        captchaCode: '',
        errorTimes: 0
      },
      loginRules: {
        username: [{
          required: true,
          trigger: 'blur',
          validator: validateUsername
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePassword
        }],
        captchaCode: [{
          required: true,
          trigger: 'blur',
          validator: validateCheckCode
        }]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      redirect: undefined,
      otherQuery: {},
      captchaUrl: '',
      showCheckCode: false,
      passwordStrengthText: '',
      passwordStrengthTextEn: '',
      passwordStrengthColor: '',
      radio: 'en'
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  watch: {
    $route: {
      handler: function handler(route) {
        var query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    open: function open() {
      var _this2 = this;
      var data = localStorage.getItem('remberPassward') || '';
      data === '1' ? this.remberPassward = true : this.remberPassward = false;
      console.log('this.remberPassward', (0, _typeof2.default)(this.remberPassward));
      if (this.remberPassward) {
        this.loginForm.username = localStorage.getItem('username') || '';
        this.loginForm.password = localStorage.getItem('password') || '';
      } else {
        setTimeout(function () {
          _this2.loginForm.username = null;
          _this2.loginForm.password = null;
        }, 800);
      }
      this.$nextTick(function () {
        if (_this2.$refs.username && _this2.$refs.username.$refs.input) {
          _this2.$refs.username.$refs.input.focus();
        } else if (_this2.$refs.username) {
          _this2.$refs.username.focus();
        }
      });
    },
    changePassward: function changePassward() {
      console.log();
      localStorage.setItem('remberPassward', this.remberPassward ? '1' : '0');
    },
    handleSetRegisterAccount: function handleSetRegisterAccount() {
      this.$router.push('/register');
    },
    handleForgetPassword: function handleForgetPassword() {
      this.$emit('forgetPassword', true);
    },
    handleForgetAccount: function handleForgetAccount() {
      this.$emit('forgetPassword', false);
    },
    handleSetLanguage: function handleSetLanguage(lang) {
      var _this3 = this;
      this.radio = lang;
      this.$i18n.locale = lang;
      this.$store.dispatch('app/setLanguage', lang);
      this.$nextTick(function () {
        _this3.$refs.loginForm.validate();
      });
    },
    checkCapslock: function checkCapslock(e) {
      var key = e.key;
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z';
    },
    showPwd: function showPwd() {
      var _this4 = this;
      if (this.passwordType) {
        this.passwordType = '';
        this.$nextTick(function () {
          _this4.$refs.password.focus();
        });
      } else {
        this.passwordType = 'password';
        this.$nextTick(function () {
          _this4.$refs.password.focus();
        });
      }
    },
    hidePwd: function hidePwd() {
      var _this5 = this;
      this.passwordType = 'password';
      this.$nextTick(function () {
        _this5.$refs.password.focus();
      });
    },
    submitLoginCode: function submitLoginCode(type, isSuccess) {
      this.showData = false;
      if (isSuccess) {
        this.handleLogin();
      }
    },
    handleLoginCode: function handleLoginCode() {
      var _this6 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this6.showData = true;
        }
      });
    },
    /* 登录 */handleLogin: function handleLogin() {
      var _this7 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this7.loading = (0, _utils.load)();
          var data = (0, _utils.deepClone)(_this7.loginForm);
          if (!_this7.showCheckCode) {
            delete data.captchaCode;
            delete data.errorTimes;
          }
          data.appCode = _this7.config.appCode;
          _this7.$store.dispatch('user/login', data).then( /*#__PURE__*/function () {
            var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(res) {
              var accessRoutes, user, userInfo;
              return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (_this7.remberPassward) {
                      localStorage.setItem('username', _this7.loginForm.username);
                      localStorage.setItem('password', _this7.loginForm.password);
                    }
                    _this7.$store.dispatch('user/getInfo');
                    _context.next = 4;
                    return _this7.$store.dispatch('permission/generateRoutes');
                  case 4:
                    accessRoutes = _context.sent;
                    _router.default.addRoutes(accessRoutes);
                    _this7.$message({
                      message: _this7.$t('home.loginSuccess'),
                      type: 'success',
                      duration: 1000
                    });
                    _this7.$router.push({
                      path: '/userCenter/userCenter'
                    });
                    user = res.data;
                    if (!(user.registUser !== 3)) {
                      _context.next = 14;
                      break;
                    }
                    // 需要修改密码，并重新登录
                    window.location.reload();
                    userInfo = sessionStorage.getItem("userInfo") && JSON.parse(sessionStorage.getItem("userInfo"));
                    if (userInfo) {
                      userInfo.registUser = user.registUser;
                      sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
                    }
                    return _context.abrupt("return");
                  case 14:
                    if (!(user.updateRegisterTermNo || user.updateBookingTermNo)) {
                      _context.next = 19;
                      break;
                    }
                    if (user.updateRegisterTermNo) {
                      sessionStorage.setItem("updateRegisterTermNo", user.updateRegisterTermNo);
                    }
                    if (user.updateBookingTermNo) {
                      sessionStorage.setItem("updateBookingTermNo", user.updateBookingTermNo);
                    }
                    window.location.reload();
                    return _context.abrupt("return");
                  case 19:
                    _this7.dialogVisible = false;
                  case 20:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()).catch(function (err) {
            if (!err) {
              _this7.$message({
                message: '系统错误',
                type: 'error'
              });
              //认证服务宕机
            } else if (typeof err == 'string' && (err.indexOf('502') > -1 || err.indexOf('404') > -1)) {
              _this7.$message({
                message: _this7.$t('login.loginServerErrTip'),
                type: 'error'
              });
            } else {
              //其他服务宕机
              if (err.errorMessages && err.errorMessages[0].indexOf('远端服务调用异常') > -1) {
                _this7.$message({
                  message: _this7.$t('login.loginServerErrTip'),
                  type: 'error'
                });
              } else {
                if (err.errorCode === 500001) {
                  _this7.$message({
                    message: _this7.$t('login.checkCodeHolder'),
                    type: 'error'
                  });
                } else {
                  _this7.$message({
                    message: err.errorMessages[0].indexOf('400') > -1 ? _this7.$t('login.loginErrTip') : err.errorMessages[0],
                    type: 'error'
                  });
                }
              }
            }
          }).finally(function () {
            _this7.loading.close();
          });
        } else {
          return false;
        }
      });
    },
    /* 获取验证码 */getCaptcha: function getCaptcha() {
      var _this8 = this;
      (0, _user.captcha)().then(function (res) {
        var data = res; // 返回的数据
        var url = window.URL.createObjectURL(new Blob([data])); // 此url如是图片格式，可赋值<img :src="url"> 做展示
        _this8.captchaUrl = url;
      });
    },
    /* 检验密码的复杂程度 */passwordStrength: function passwordStrength(str) {
      if (!str) {
        this.passwordStrengthText = '';
        this.passwordStrengthTextEn = '';
        return;
      }
      var _color = ['red', 'gray', 'orange', 'green'];
      var msgs = ['密码太短', '弱', '中', '强'];
      var msgsEn = ['Too Short', 'Weak', 'Medium', 'Strong'];
      var _strength = 0;
      var _v = str.replace(/^(\s|\u00a0)+|(\s|\u00a0)+$/g, '');
      var _vL = _v.length;
      var i = 0;
      var charStrength = function charStrength(char) {
        // 计算单个字符强度
        if (char >= 48 && char <= 57) {
          // 数字
          return 1;
        }
        if (char >= 97 && char <= 122) {
          // 小写
          return 2;
        } else {
          return 3; // 特殊字符
        }
      };
      if (_vL < 6) {
        // 计算模式
        this.passwordStrengthText = msgs[0];
        this.passwordStrengthTextEn = msgsEn[0];
        this.passwordStrengthColor = _color[0];
      } else {
        for (; i < _vL; i++) {
          // 遍历字符
          _strength += charStrength(_v.toLocaleLowerCase().charCodeAt(i));
        }
        if (_strength < 10) {
          // 强度小于10
          this.passwordStrengthText = msgs[1];
          this.passwordStrengthTextEn = msgsEn[1];
          this.passwordStrengthColor = _color[1];
        }
        if (_strength >= 10 && _strength < 15) {
          this.passwordStrengthText = msgs[2];
          this.passwordStrengthTextEn = msgsEn[2];
          this.passwordStrengthColor = _color[2];
        }
        if (_strength >= 15) {
          this.passwordStrengthText = msgs[3];
          this.passwordStrengthTextEn = msgsEn[3];
          this.passwordStrengthColor = _color[3];
        }
      }
    },
    getOtherQuery: function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    handleSendActivationEmail: function handleSendActivationEmail() {
      this.sendActivationEmailUsername = this.loginForm.username;
      this.sendActivationEmailVisible = true;
    }
  }
};